import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
export const SamplesSize = () => {
  return <div className="py-20 lg:py-24 bg-white min-h-[calc(100vh-300px)]" data-id="element-1101">
      <div className="max-w-content mx-auto px-5 sm:px-8 lg:px-12" data-id="element-1102">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-1103">
          <span className="text-sm font-bold uppercase tracking-wider text-brandRed" data-id="element-1104">
            Samples
          </span>
          <h1 className="text-4xl md:text-5xl font-heading font-bold text-ink mt-3 mb-5 leading-tight" data-id="element-1105">
            Size Samples
          </h1>
          <p className="text-lg text-gray-600 leading-relaxed" data-id="element-1106">
            Ensure the perfect fit for your team before placing a full order.
            Request a sizing run of our custom apparel.
          </p>
        </div>

        <div className="max-w-3xl mx-auto prose prose-lg prose-red text-gray-600" data-id="element-1107">
          <p data-id="element-1108">
            We highly recommend ordering a size run before finalizing large team
            orders. Custom apparel is made-to-order and cannot be returned due
            to sizing issues.
          </p>
          <h3 data-id="element-1109">How Sizing Samples Work</h3>
          <ul data-id="element-1110">
            <li data-id="element-1111">
              <strong data-id="element-1112">Full Size Runs:</strong> We provide a complete range of
              sizes (e.g., Youth Small through Adult 3XL) for the specific
              garment style you are ordering.
            </li>
            <li data-id="element-1113">
              <strong data-id="element-1114">Blank Garments:</strong> Sizing samples are typically
              blank (unprinted) garments made from the exact fabric and pattern
              as your final order.
            </li>
            <li data-id="element-1115">
              <strong data-id="element-1116">Deposit Required:</strong> A deposit is required for
              sizing samples. This deposit is fully refundable upon the return
              of the samples in good condition within 30 days.
            </li>
          </ul>

          <div className="mt-10 text-center not-prose" data-id="element-1117">
            <Link to="/contact" className="inline-flex items-center justify-center gap-2 bg-brandRed hover:bg-brandRedDark text-white font-bold py-4 px-8 rounded-sm transition-colors text-base shadow-lg" data-id="element-1118">
              Request Size Samples
              <ArrowRight className="w-5 h-5" data-id="element-1119" />
            </Link>
          </div>
        </div>
      </div>
    </div>;
};